import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLoginUrl } from "../helpers/authConfig";
import { hasStoredSession, isDevSessionEnabled, storedPrimaryOrganisation } from "../helpers/devSession";
import { homeRoutes } from "./auth";

function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        // Local dev session already bootstrapped (helpers/devSession.ts): go
        // straight to the org's home page instead of the Cognito hosted UI.
        if (isDevSessionEnabled() && hasStoredSession()) {
            navigate(homeRoutes(storedPrimaryOrganisation()) || "/home", { replace: true });
            return;
        }
        window.location.href = getLoginUrl();
    }, [navigate]);

    return <div className="Login"></div>;
}

export default Login;
